import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_APPLICATIONPATIENTCHATRIGHT_FULFILLED = "FETCH_APPLICATIONPATIENTCHATRIGHT_FULFILLED";
export const FETCH_APPLICATIONPATIENTCHATRIGHT_REJECTED = "FETCH_APPLICATIONPATIENTCHATRIGHT_REJECTED";
export const FETCH_APPLICATIONPATIENTCHATRIGHT_PENDING = "FETCH_APPLICATIONPATIENTCHATRIGHT_PENDING";
export const RESET_APPLICATIONPATIENTCHATRIGHT = "RESET_APPLICATIONPATIENTCHATRIGHT"

export function applicationPatientChatRight(applicationId) {
    const token = localStorage.getItem("accessToken")

    return dispatch => {
        dispatch({
          type: "FETCH_APPLICATIONPATIENTCHATRIGHT",
          payload: axios({
            method: "get",
            url: `${API_BASE}/api/v3/second-opinion/application-patient-chat-right?applicationId=${applicationId}`,
            headers: {
                "Authorization": "Bearer " + token,
                "Accept-Language": "tr-tr",
                "Client-Id": localStorage.getItem("One-Id"),
                "One-Id": localStorage.getItem("Client-Id"),
                "Content-Type": "application/json",
                "ngrok-skip-browser-warning" : "69920"
            },
          }).then((result) => result.data),
        });
      };
}


export function resetApplicationPatientChatRight() {
  return (dispatch) => {
      dispatch({
          type: "RESET_APPLICATIONPATIENTCHATRIGHT",
      });
  };
}


